import { z } from 'zod';
import { BiomeIdSchema } from '../data/biomes.js';
import { BOUNTY_MOB_IDS } from '../data/bounties.js';
import { ContractSchema } from '../data/contracts.js';
/**
 * The villages' wanted boards (ADR 0096). The client names the board it
 * stands at (its entity id) and a bounty by its slot; the server checks the
 * distance, draws the day's bounties, raises the target for the taker and
 * pays in one transaction once the career shows it slain.
 */
/** `meadow-0`: the board's biome and the bounty's place on it. */
export const BountySlotSchema = z.string().regex(/^[a-z]+-\d$/);
export const BountySchema = z.object({
    slot: BountySlotSchema,
    mob: z.enum(BOUNTY_MOB_IDS),
    biome: BiomeIdSchema,
    reward: ContractSchema.shape.reward,
});
export const BountiesRequestSchema = z.object({ boardId: z.string().min(1).max(64) }).strict();
export const BountyTakeMessageSchema = z
    .object({ boardId: z.string().min(1).max(64), slot: BountySlotSchema })
    .strict();
export const BountyClaimMessageSchema = BountyTakeMessageSchema;
/**
 * `open`: to be taken; `out`: its target stands for this player; `done`:
 * slain, the reward waits at the board; `claimed`: paid.
 */
export const BOUNTY_STATES = ['open', 'out', 'done', 'claimed'];
export const BountyViewSchema = BountySchema.extend({
    state: z.enum(BOUNTY_STATES),
    /** The named place it waits at, by its French name (translated where shown). */
    near: z.string().min(1),
    x: z.number().int(),
    y: z.number().int(),
});
/** A board's bounties of the day, to the player who reads it, and when they renew. */
export const BountiesEventSchema = z.object({
    boardId: z.string().min(1),
    biome: BiomeIdSchema,
    bounties: z.array(BountyViewSchema),
    dayEndsInMs: z.number().int().min(0),
});
export const BountyClaimedSchema = z.object({
    slot: BountySlotSchema,
    gold: z.number().int().min(0),
    items: ContractSchema.shape.reward.shape.items,
});
export const BOUNTY_REFUSALS = [
    'invalid',
    /** Too far from the board. */
    'far',
    /** Under the region's band of levels. */
    'level',
    /** Another bounty's target, or a quest's bait's catch, already stands for this player. */
    'hunting',
    /** No open tile at its place: try again later. */
    'no-room',
    'not-done',
    'claimed',
    'bag-full',
    'busy',
];
export const BountyRejectedSchema = z.object({ reason: z.enum(BOUNTY_REFUSALS) });
//# sourceMappingURL=bounties.js.map